'use client';

import { Anchor } from '@/components/ui/anchor';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import Image from 'next/image';

export const JoinNow = (): React.JSX.Element | null => {
  const { trackClick } = useDataAnalytics();

  return (
    <div className="flex justify-center gap-ms">
      <div className="flex flex-col gap-ms">
        <picture>
          <source srcSet="/img/movie-rewards/logo_mf_2025.png 1x, /img/movie-rewards/logo_mf_2025@2x.png 2x"/>
          <Image alt="Cinemark Movie Rewards Movie Fan"
            className="w-full"
            height={30}
            src="/img/movie-rewards/logo_mf_2025.png"
            width={105}
          />
        </picture>

        <Anchor className="w-full"
          data-test="link-header-join-now"
          href="/membership/register?returnurl=/movie-rewards-info"
          size="lg"
          onClick={() => trackClick({
            linkCategory: AnalyticsPageCategories.MOVIE_REWARDS,
            linkName: 'Join Now',
          })}
        >
          Join Now
        </Anchor>
      </div>

      <div className="flex flex-col gap-ms">
        <picture>
          <source srcSet="/img/movie-rewards/logo_mc_2025.png 1x, /img/movie-rewards/logo_mc_2025@2x.png 2x"/>
          <Image alt="Cinemark Movie Rewards Movie Club"
            className="w-full"
            height={30}
            src="/img/movie-rewards/logo_mc_2025.png"
            width={105}
          />
        </picture>

        <Anchor className="w-full"
          data-test="link-header-upgrade"
          href="/movieclub"
          size="lg"
          onClick={() => trackClick({
            linkCategory: AnalyticsPageCategories.MOVIE_REWARDS,
            linkName: 'Upgrade',
          })}
        >
          Upgrade
        </Anchor>
      </div>
    </div>
  );
};
